<template>
  <div class="mt-6">
    <p class="text-lg font-bold text-root-2">Yield Profiles</p>
    <div class="mt-6" v-if="isLoading">
      <spinner
        size="medium"
        :spacing="40"
        message=""
        :line-fg-color="$primaryColor"
      />
    </div>
    <div v-else class="card bg-root w-full p-6 mt-4">
      <yield-offering-table
        @goToCreateYieldForm="goToCreateYieldForm"
        :tableData="yieldOfferingTableData"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'YieldOfferings',
  data () {
    return {
      isLoading: false,
      payload: {
        page: 1,
        size: 10,
        status: '',
        type: '',
        from: '',
        to: ''
      }
    }
  },
  components: {
    YieldOfferingTable: () =>
      import('@/components/externalApi/tables/YieldOfferingTable.vue')
  },
  methods: {
    goToCreateYieldForm () {
      this.$emit('goToCreateYieldForm')
    },
    getYieldOfferingProfilesInformation () {
      this.isLoading = true
      const vm = this
      this.$store
        .dispatch(
          'externalApi/getYieldOfferingProfilesInformation',
          this.payload
        )
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  mounted () {
    this.getYieldOfferingProfilesInformation()
  },
  computed: {
    yieldOfferingTableData () {
      return (
        this.$store.state.externalApi.yieldOfferingProfilesInformation.items ||
        []
      )
    }
  }
}
</script>

<style scoped>
>>> .el-tabs__item.is-active {
  color: var(--color-primary);
}
>>> .el-tabs__active-bar.is-top {
  background: var(--color-primary);
}
>>> .el-tabs__item:hover {
  color: var(--color-primary);
}
>>> .el-tabs__item {
  color: var(--text-4);
}
>>> .el-input__inner {
  border-radius: 28px;
  height: 30px;
}
.btn {
  background: rgba(1, 5, 44, 0.05);
  border: 0.719333px solid #c1c4ca;
  border-radius: 6px;
}
.card {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.12),
    0px 2px 4px rgba(3, 2, 7, 0.12);
  border-radius: 15px;
}
</style>
